module.exports = __webpack_public_path__ + "static/media/modulo-comercial.2c2bc46a.svg";